import React, { useState, useEffect } from 'react';
import * as styles from '../../styles/components/ConfirmationDialog.less';

interface ConfirmationDialogProps {
  message?: string;
  onConfirm: (inputValue: string) => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  showInput?: boolean;
  inputLabel?: string;
}

const ConfirmationDialog = ({
    message,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    showInput = false,
    inputLabel = ''
}: ConfirmationDialogProps) => {
    const [inputValue, setInputValue] = useState('');

     // Reset input field when dialog opens
  useEffect(() => {
    setInputValue('');
  }, [showInput]);

  const handleConfirm = () => {
    onConfirm(inputValue); // Pass the input back to parent
  };

  return (
    <div className={styles['modal-backdrop']}>
      <div className={styles.modal}>
        <p>{message}</p>

        {showInput && (
          <div className={styles['modal-input']}>
            {inputLabel && <label>{inputLabel}</label>}
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
        )}

        <div className={styles['modal-buttons']}>
          <button onClick={onCancel}>{cancelText}</button>
          <button onClick={handleConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConfirmationDialog);

